// รอบนี้ต้องตรวจ / จองที่นั่งไหม — ใช้ร่วมกันระหว่าง seatRequest / seatMain / seatSecond
// กติกาอยู่ที่ decideSkipSeatCheck (utils/seatRules.ts) ไฟล์นี้แค่เก็บข้อมูลจาก browser ให้

import type { Router } from "vue-router";
import { isBetaSite, isBetaWhitelisted } from "../../core/utils/authHandoff";
import { decideSkipSeatCheck } from "../utils/seatRules";

// อ่าน beta_whitelist ครั้งเดียวต่อการเปิดแอป (plugin ทั้งสามตัวถามซ้ำได้)
const whitelistCache = new Map<string, Promise<boolean>>();

/**
 * @param router ส่งมาจากผู้เรียก — seatSecond เรียกจาก hook app:mounted
 *   ซึ่งไม่อยู่ใน nuxt context แล้ว useRouter() ใช้ไม่ได้
 */
export function shouldSkipSeatCheck(storeId: string, router: Router): Promise<boolean> {
  return decideSkipSeatCheck({
    freeAuthPage: isFreeAuthPage(router),
    onBetaSite: isBetaSite(),
    localhost: window.location.hostname === "localhost",
    isWhitelisted: () => {
      if (!whitelistCache.has(storeId)) whitelistCache.set(storeId, isBetaWhitelisted(storeId));
      return whitelistCache.get(storeId) as Promise<boolean>;
    },
  });
}

// ดูจาก URL จริงของหน้า ไม่ใช่ currentRoute — ตอน plugin รันก่อน mount router ยังไม่ resolve หน้าแรก
function isFreeAuthPage(router: Router): boolean {
  try {
    return Boolean(router.resolve(window.location.pathname).meta?.freeAuth);
  } catch {
    return false;
  }
}
